import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLineCardExpandedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardExpanded";
import { css } from "styled-components";

cartLineCardExpandedStyles.extendedUnitNetPriceText = mergeToNew(cartLineCardExpandedStyles.extendedUnitNetPriceText, {
    weight: "bold",
    color: "text.accent",
});

cartLineCardExpandedStyles.vatLabelText = mergeToNew(cartLineCardExpandedStyles.vatLabelText, {
    color: "text.accent",
});

cartLineCardExpandedStyles.subtotalWithoutVatText = mergeToNew(cartLineCardExpandedStyles.subtotalWithoutVatText, {
    weight: "bold",
    color: "text.accent",
    css: css`
        margin-top: 5px;
    `,
});

cartLineCardExpandedStyles.productPrice = mergeToNew(cartLineCardExpandedStyles.productPrice, {
    priceLabelText: {
        size: 14,
    },
});
